import { Component, OnInit, ViewEncapsulation, AfterViewInit } from '@angular/core';
import { CommanHelperService } from '../service/commanHelper.service';
import { DialogComponent, DialogService } from "ng2-bootstrap-modal";
import { ActivatedRoute, Router } from '@angular/router';
export interface ConfirmModel {
    title: string;
    message: string;
    okBtn?: string;
    okBtn2?: string;
    phone?: string;
    email?: string;
    isAvailable?: boolean;
    okAvailable?: boolean;
    showLoginRoute?: boolean;
    onlyReg?: boolean;
}

@Component({
    selector: 'deletePoup',
    templateUrl: '../DeletPoup/delete.component.html',
    styleUrls: ['../DeletPoup/delete.component.scss'],
    encapsulation: ViewEncapsulation.None,
})

export class DeletPoupComponrnt extends DialogComponent<ConfirmModel, boolean> implements ConfirmModel, AfterViewInit {
    title: string = '';
    message: string = '';
    okBtn: string = 'OK';
    okBtn2: string = 'Email Support';
    cancelBtn: any = 'Cancel';
    isAvailable: boolean = true;
    okAvailable: boolean = true;
    showLoginRoute: boolean = false;
    phone: string = '';
    email: string = '';
    onlyReg: boolean = false;


    constructor(public dialogService: DialogService, private router: Router, private route: ActivatedRoute) {
        super(dialogService);
        this.route.queryParams.subscribe((params) => {
            let lang;
            lang = params['lang'];
            if (lang == 'es') {
                this.cancelBtn = 'Cancelar';
            } else {
                this.cancelBtn = 'Cancel';
            }
        });
    }
    ngAfterViewInit() {
        setTimeout(() => {
            const titleElement = document.getElementById('modalTitle');

            if (titleElement) {
                titleElement.focus();
            }
        }, 100);
    }

    confirm() {
        this.result = true;
        this.close();
    }

    cancel() {
        this.result = true;
        this.close();
    }
    routeBtn() {
        if (this.onlyReg) {
            let Toroute = window.location.origin
            setTimeout(() => {
                window.location.href = Toroute;
            }, 200);
        } else {
            this.cancel();
        }

    }
    callSupport() {
        if (this.phone) {
            window.location.href = `tel:${this.phone}`;
        } else {
            this.cancel();
        }
    }

    emailSupport() {
        if (this.email) {
            window.location.href = `mailto:${this.email}`;
        } else {
            this.cancel();
        }
    }

}
